"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapFromResult = exports.unwrapErrFromResult = exports.unwrapOkFromResult = void 0;
var expect_1 = require("./expect");
/**
 *  Return the inner `T` of a `Ok(T)`.
 *
 *  @throws {TypeError}
 *      Throws if the self is a `Err`.
 */
function unwrapOkFromResult(input) {
    return (0, expect_1.expectOkForResult)(input, 'called with `Err`');
}
exports.unwrapOkFromResult = unwrapOkFromResult;
/**
 *  Return the inner `E` of a `Err(E)`.
 *
 *  @throws {TypeError}
 *      Throws if the self is a `Ok`.
 */
function unwrapErrFromResult(input) {
    return (0, expect_1.expectErrForResult)(input, 'called with `Ok`');
}
exports.unwrapErrFromResult = unwrapErrFromResult;
/**
 *  @deprecated
 *  Use {@link unwrapOkFromResult}
 */
exports.unwrapFromResult = unwrapOkFromResult;
